export default {
  common: {
    language: '语言',
    langZhCN: '简体中文',
    langEnUS: 'English',
    confirm: '确定',
    backToSignIn: '返回登录页面',
    login: '登录',
    username: '用户名',
    password: '密码',
    success: '成功',
    systemErrorRetry: '系统错误，请稍后重试。',
  },
  loading: {
    dataLoading: '数据加载中...',
    loginLoading: '登录中...',
  },
  app: {
    titles: {
      forgetPassword: '忘记密码',
      resetPassword: '重置密码',
      bindAccount: '第一次{accountType}登录，请绑定您的账号',
    },
    accountTypes: {
      wx: '微信',
      wxWork: '企业微信',
      dingTalk: '钉钉',
      alipay: '支付宝',
      other: '其他',
    },
  },
  forgetPassword: {
    tip: '请填写以下信息，我们将向您的邮箱发送密码重置链接',
    placeholders: {
      name: '请输入姓名',
      staffNo: '请输入用户名',
      email: '请输入预留邮箱地址',
    },
    submit: '提交重置请求',
    resultTitle: '密码重置',
    resultDescription: '密码重置邮件已发送，请查收邮件并点击链接重置密码。',
    errors: {
      resetFailed: '重置密码失败',
      retryLater: '重置密码失败，请稍后重试。',
      systemError: '系统错误，请稍后重试。',
      invalidEmail: '请输入有效的邮箱地址',
    },
    rules: {
      nameRequired: '请输入姓名',
      staffNoRequired: '请输入用户名',
      emailRequired: '请输入预留邮箱地址',
    },
  },
  signIn: {
    placeholders: {
      username: '请输入用户名',
      password: '请输入登录密码',
      captcha: '请输入验证码',
    },
    defaultPasswordTip: {
      line1: '初始密码为Fap+身份证后六位（字母小写）+!',
      line2: '例：Fap123456!、Fap12345x!。',
    },
    actions: {
      forgotPassword: '忘记密码',
      bind: '绑定',
      otherSignInMethods: '其他登录方式',
    },
    slideVerifyText: '滑动模块完成上方拼图',
    rules: {
      usernameRequired: '账号必填',
      passwordRequired: '密码必填',
      captchaRequired: '验证码必填',
    },
    errors: {
      captchaInitFailed: '验证码初始化失败',
      bindError: '绑定错误',
      configErrorTitle: '错误',
      configErrorDescription: '系统配置错误',
    },
  },
  changePassword: {
    tip: '为了您的账户安全，请修改初始密码，新密码须为7到16位，需包含英文（区分大小写）、数字和常用符号',
    placeholders: {
      password: '请输入新密码',
      passwordConfirm: '请重复输入新密码',
      passwordConfirmAgain: '请再次输入新密码',
    },
    actions: {
      submit: '修改密码',
      resetSubmit: '重置密码',
    },
    rules: {
      passwordRequired: '密码必填',
      passwordNotSameAsOld: '不能与旧密码相同',
      passwordInvalid: '不符合密码规定',
      passwordInvalidDetailed: '密码不符合规定：需为7到16位，包含大小写字母、数字和符号',
      passwordConfirmRequired: '重复密码必填',
      passwordConfirmNotMatch: '两次输入的密码不匹配！',
      passwordConfirmNotMatchPlain: '两次输入的密码不匹配',
    },
    errors: {
      resetLinkInvalid: '重置链接无效或已过期，请返回登录页重新发起重置密码。',
      resetFailed: '重置密码失败',
      resetRetryLater: '重置密码失败，请稍后重试。',
      resetSuccess: '密码重置成功！',
    },
  },
  recoveryEmail: {
    tip: '请设置密保邮箱，忘记密码时可通过该邮箱接收密码重置链接。',
    placeholders: {
      email: '请输入密保邮箱',
      verificationCode: '请输入邮箱验证码',
    },
    actions: {
      resend: '重新发送',
      sendEmail: '发送邮件',
      verifyAndSave: '验证并保存',
      skip: '跳过',
    },
    dialogs: {
      sendFailed: '发送失败',
      sendSuccess: '发送成功',
      verifyFailed: '验证失败',
      setupSuccess: '密保邮箱设置成功。',
      emailSentTemplate: '验证邮件已发送至 {email}，请查收邮件并输入邮件中的验证码完成设置。',
      sendRetryLater: '发送失败，请稍后重试。',
      verifyRetryLater: '验证码校验失败，请稍后重试。',
    },
    rules: {
      emailRequired: '请输入密保邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      verificationCodeRequired: '请输入邮箱验证码',
    },
  },
  mobileCompletion: {
    tip: '为完善账号信息，请填写或核对您的手机号。如号码有误可直接修改，提交后将自动继续登录。',
    placeholder: '请输入11位手机号码',
    submit: '提交并继续登录',
    mobileRequired: '请输入手机号码',
    mobileInvalid: '请输入有效的11位中国大陆手机号码',
    failed: '手机号提交失败',
    expired: '当前操作已失效，请重新发起登录。',
    retryLater: '提交失败，请稍后重试。',
  },
  result: {
    back: '返回',
  },
};
